import React from 'react';
import { Link } from 'react-router-dom';
import { Mail } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-50 border-t border-gray-200 mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_3bc65fda-5585-4ce4-b680-6a6da9f38893/artifacts/k1tiv14k_brxresource.jpg" 
              alt="BRX Resource logo" 
              className="h-10 mb-4"
            />
            <p className="text-sm text-gray-600 mb-2">Registered in India</p>
            <p className="text-sm text-gray-600">Noida, Uttar Pradesh, India</p>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-sm font-semibold text-gray-900 mb-4">Contact</h3>
            <div className="space-y-2">
              <a href="mailto:info@brxresource.com" className="flex items-center text-sm text-gray-600 hover:text-blue-900 transition-colors">
                <Mail size={16} className="mr-2" aria-hidden="true" />
                <span>info@brxresource.com</span>
              </a>
              <p className="text-xs text-gray-500 ml-6">General & Partnerships</p>
              <a href="mailto:finance@brxresource.com" className="flex items-center text-sm text-gray-600 hover:text-blue-900 transition-colors">
                <Mail size={16} className="mr-2" aria-hidden="true" />
                <span>finance@brxresource.com</span>
              </a>
              <p className="text-xs text-gray-500 ml-6">Billing & Finance</p>
            </div>
          </div>

          {/* Legal Links */}
          <div>
            <h3 className="text-sm font-semibold text-gray-900 mb-4">Legal</h3>
            <nav aria-label="Legal pages">
              <div className="space-y-2">
                <Link to="/privacy-policy" className="block text-sm text-gray-600 hover:text-blue-900 transition-colors">
                  Privacy Policy
                </Link>
                <Link to="/terms-of-use" className="block text-sm text-gray-600 hover:text-blue-900 transition-colors">
                  Terms of Use
                </Link>
                <Link to="/disclaimer" className="block text-sm text-gray-600 hover:text-blue-900 transition-colors">
                  Disclaimer
                </Link>
              </div>
            </nav>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-12 pt-8 border-t border-gray-200">
          <p className="text-sm text-gray-500 text-center">
            © {new Date().getFullYear()} BRX Resource. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;